import { routes } from "@/constants/url.ts";
import { supabase } from "@/lib/supabase";
import { cn } from "@/lib/utils";
import { Button } from "@backpac/monica";

interface SignInWithGoogleButtonProps {
  className?: string;
  text?: string;
  redirectTo?: string;
  size?: "sm" | "md" | "lg";
}

export function SignInWithGoogleButton({ className, text, redirectTo, size = "lg" }: SignInWithGoogleButtonProps) {
  const handleOAuthSignIn = () =>
    supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: redirectTo ?? `${window.location.origin}${routes.AUTH.callback}`,
        queryParams: {
          prompt: "select_account",
        },
      },
    });

  return (
    <Button className={cn("w-full", className)} variant="outlined" size={size} onClick={handleOAuthSignIn}>
      <i className="inline-block i-bp-google mr-1 w-4 h-4" />
      {text ?? "Sign in with Google"}
    </Button>
  );
}
